import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import { addLocalePrefix } from 'lib/addLocalePrefix'

//component
import HeaderMenuComponent from '../menus/HeaderMenuComponent'

import styles from './HeaderComponent.module.scss'

interface Props {
  onPressHamburgerMenu: () => void
  isOpenMenu: boolean
}

const HeaderComponent: React.VFC<Props> = ({
  onPressHamburgerMenu,
  isOpenMenu,
}: Props): JSX.Element => {
  const { t } = useTranslation()
  const { locale } = useRouter()

  return (
    <header className={`${styles.header} ${isOpenMenu ? styles.openSideMenu : ''}`}>
      <div className={styles.headerBox}>
        <div className={styles.headerLeft}>
          <div className={styles.headerLeftItem}>
            <div
              className={`${styles.hamburgerMenu} ${isOpenMenu ? styles.open : ''}`}
              onClick={onPressHamburgerMenu}
            >
              <span />
              <span />
              <span />
            </div>
            <div className={isOpenMenu ? styles.hideLogo : ''}>
              <Link href={addLocalePrefix('/', locale)}>
                <img
                  className={styles.logo}
                  src="/logo.webp"
                  alt={t('META.LOGO')}
                  height="30px"
                  width="130px"
                />
              </Link>
            </div>
          </div>
        </div>
        <nav className={styles.headerRight}>
          <HeaderMenuComponent />
        </nav>
      </div>
    </header>
  )
}

export default HeaderComponent
